<template>
  <v-card class="speaker-card pb-2" max-width="1600">
    <div class="header"></div>
    <div class="px-3">
      <v-container class="pt-5 pb-0">
        <h3 class="pb-1">{{ title }}</h3>
        <div class="summary pt-1">
          <div class="submenu">
            <v-icon>mdi-clock-outline</v-icon><span>{{ time }}</span>
          </div>
          <div
            class="submenu"
            v-if="languages !== undefined && languages[0] !== ''">
            <v-icon>mdi-web</v-icon>
            <span v-for="(language, i) in languages" :key="'lang' + i">
              {{ language }}
            </span>
          </div>
          <div class="submenu">
            <!-- <v-btn
              text
              @click="downloadAbstract()"
              :disabled="!this.isAbstractAvailable"
              class="pa-0 mt-1">
              <v-icon dense class="pt-1">mdi-tray-arrow-down</v-icon
              ><span>{{ $t("sessionSchedule.abstract") }}</span>
            </v-btn> -->
          </div>
        </div>
        <!-- <v-container v-if="presentationTitles && presentationTitles.length > 0">
          <div
            v-for="(presentationTitle, i) in presentationTitles"
            :key="'presentationTitle' + i">
            <span>- {{ presentationTitle }}</span>
          </div>
        </v-container> -->
      </v-container>
      <v-container v-if="applicants && applicants.length > 0" class="pt-0 pb-5">
        <v-row>
          <v-col
            cols="12"
            class="pb-1"
            v-if="
              applicants.filter((applicant) => applicant.applicantTypeId === 1)
                .length > 0
            ">
            <h4 class="pt-1 pb-3">{{ $t("daySchedule.speakers") }}</h4>
            <div v-for="(applicant, i) in applicants" :key="'speaker' + i">
              <v-expansion-panels
                focusable
                v-if="applicant.applicantTypeId == 1"
                class="speaker-panel">
                <v-expansion-panel
                  :readonly="applicant.biography == ''"
                  expand->
                  <v-expansion-panel-header>
                    <v-container>
                      <v-row>
                        <v-col class="padding-speakers d-flex flex-row">
                          <div>
                            <v-avatar size="70px" v-if="applicant.imageUrl">
                              <img alt="Avatar" :src="applicant.imageUrl" />
                            </v-avatar>
                            <v-avatar size="70px" v-else>
                              <v-icon class="avatar-empty">
                                mdi-account-circle-outline
                              </v-icon>
                            </v-avatar>
                          </div>
                          <v-container class="pa-0">
                            <h3 class="pb-1">{{ applicant.name }}</h3>
                            <p class="speaker-title">
                              {{ applicant.role }}
                              <span v-if="applicant.company">
                                {{ applicant.company }}
                              </span>
                            </p>
                          </v-container>
                        </v-col>
                      </v-row>
                    </v-container>
                    <template v-slot:actions v-if="applicant.biography == ''">
                      <v-icon></v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <p class="pt-3 biography mb-0">{{ applicant.biography }}</p>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </v-col>
          <v-col
            cols="12"
            class="coauth-panel"
            v-if="
              applicants != null &&
              applicants.filter((applicant) => applicant.applicantTypeId === 2)
                .length > 0
            ">
            <h4 class="pb-1">{{ $t("sessionSchedule.co-authors") }}</h4>
            <div
              v-for="(applicant, i) in applicants"
              :key="'author' + i"
              class="coauth-text">
              <div v-if="applicant.applicantTypeId === 2">
                {{ applicant.name
                }}<span v-if="applicant.company"
                  >{{ $t("sessionSchedule.from") }}
                  {{ applicant.company }}</span
                ><span v-if="i < applicant.length - 1"> </span> <br />
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "SpeakerCard",
  props: {
    time: {
      type: String,
      required: true,
    },
    presentationTitles: {
      type: Array,
      default() {
        return [];
      },
    },
    languages: {
      type: Array,
      default() {
        return [];
      },
    },
    isAbstractAvailable: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    applicants: {
      type: Array,
    },
    id: {
      type: Number,
    },
  },
  methods: {
    downloadAbstract() {
      this.$store.dispatch("fetchDownloadSessionAbstract", {
        id: this.id,
        eventname: this.title,
      });
    },
  },
};
</script>
